import "./App.css";
import { AuthProvider, useAuth } from "./components/features/AuthContext";
import { Routes, Route, Navigate } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { TooltipProvider } from "./components/ui/tooltip";
import { Toaster } from "./components/ui/toaster";
import { Layout } from "./components/Layout";
import NotFound from "./pages/NotFound";
import Dashboard from "./pages/dashboard";
import UserManagement from "./pages/user-management";
import PlatformIntegration from "./pages/platform-integration";
import BucketManagement from "./pages/bucket-management";
import AutoTrade from "./pages/AutoTrade";
import OrderSettings from "./pages/order-settings";
import ManualTesting from "./pages/manual-testing";
import Login from "./components/Login";
import { queryClient } from "./components/lib/queryClient";
import Loading from "./components/ui/Loading";
import FilterManagement from "./pages/filter-management";
import ServicesManagement from "./pages/services_managment";
import OrderHistory from "./pages/OrderHIstory";
import LeaderManagement from "./pages/LeaderAssetManagement";
import TelegramAlertsPage from "./pages/LiqidationAlertPage";
import Backtesting from "./pages/backtesting";
import SystemConfig from "./pages/system-config";


function ProtectedRoutes() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/filters" element={<FilterManagement />} />
        <Route path="/users" element={<UserManagement />} />
        <Route path="/buckets" element={<BucketManagement />} />
        <Route path="/leader-integration" element={< LeaderManagement/>} />
         <Route path="/liquidation-alert" element={< TelegramAlertsPage/>} />
        <Route path="/platform-integration" element={<PlatformIntegration />} />
        <Route path="/manual-testing" element={<ManualTesting />} />
        <Route path="/order-settings" element={<OrderSettings />} />
        <Route path="/auto-trade" element={<AutoTrade />} />
        <Route path="/order-history" element={<OrderHistory />} />
        <Route path="/services" element={<ServicesManagement />} />
        <Route path="/backtesting" element={<Backtesting />} />
        <Route path="/system-config" element={<SystemConfig />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Layout>
  );
}

function PublicRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}

function Router() {
  const { authorized, loading } = useAuth();
  if (loading) {
    return <Loading fullScreen />;
  }

  return authorized ? <ProtectedRoutes /> : <PublicRoutes />;
}

function App() {
  return (
    <AuthProvider>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <Toaster />
          <Router />
        </TooltipProvider>
      </QueryClientProvider>
    </AuthProvider>
  );
}

export default App;